import { ActivityCategory, activityCategories } from "@sp-crm/core";
import { useFeature } from "store/selectors/hooks";

export const useAvailableActivityCategories = (): readonly ActivityCategory[] => {
    const eventsEnabled = useFeature("events");
    return eventsEnabled
        ? activityCategories
        : activityCategories.filter(category => category !== "event");
};
